/**
 * CRM Route Utilities
 * Maps plan categories to URL slugs and vice versa
 */

// Plan category (from DB) → URL slug
export const categoryToSlug = {
  real_estate: 'realestate',
  wholesalers: 'wholesale',
  probate: 'probate',
  home_flippers: 'flipper',
};

// URL slug → plan category
export const slugToCategory = {
  realestate: 'real_estate',
  wholesale: 'wholesalers',
  probate: 'probate',
  flipper: 'home_flippers',
};

// All valid CRM slugs
export const validCrmSlugs = Object.keys(slugToCategory);

// Slug → crmType used in Layout navigation filtering
export const slugToCrmType = {
  realestate: 'real_estate',
  wholesale: 'wholesaler',
  probate: 'probate',
  flipper: 'flipper',
};

/**
 * Get the CRM base path for a user based on their plan category
 * @param {string} category - The plan category from user.plan.category
 * @returns {string} The base CRM path (e.g., '/realestate', '/wholesale')
 */
export function getCrmBasePath(category) {
  const slug = categoryToSlug[category] || 'realestate';
  return `/${slug}`;
}

/**
 * Get CRM dashboard path for a user
 * @param {string} category - The plan category
 * @returns {string} Full dashboard path
 */
export function getCrmDashboardPath(category) {
  return `${getCrmBasePath(category)}/dashboard`;
}

/**
 * Check if a URL slug is a valid CRM slug
 * @param {string} slug 
 * @returns {boolean}
 */
export function isValidCrmSlug(slug) {
  return validCrmSlugs.includes(slug);
}
